<template>
  <div class="vote-box">
    <div class="vote-choose flex">
      <div
        class="vote-list flex"
        @click="chooseOne(index)"
        v-for="(item, index) in getList"
        :key="index"
      >
        <img src="./images/choose_bg.png" v-if="chooseWhich == index" />
        <img src="./images/choose_border.png" v-else />
        <span class="S8 T1">{{ item.authorName }}</span>
      </div>
    </div>
    <div class="btn-box flex">
      <span class="S8 T5" @click="lookRank">
        查看排名
      </span>
      <span class="S8 T5" @click="voteNow">
        立即投票
      </span>
    </div>
    <van-dialog
      v-model="showDialog"
      show-cancel-button
      confirmButtonText="查看排名"
      cancelButtonText="完成"
      confirmButtonColor="#046BCC"
      @confirm="lookRank"
    >
      <div class="S8 T1 vote-tip">投票成功</div>
    </van-dialog>
  </div>
</template>
<script>
import { Log } from '@em/ym'
import { Toast, Dialog } from 'vant'
import { isGuest } from '@/api/appInfo'
import util from '@/util/util'
import api from '@/api/api'
export default {
  components: {
    'van-dialog': Dialog.Component
  },
  props: {
    getList: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    }
  },
  data() {
    return {
      chooseWhich: -1,
      showDialog: false
    }
  },

  methods: {
    chooseOne(index) {
      if (isGuest()) {
        util.go('ycstock://login')
        return
      }
      Log.click({
        eventId: 'chooseOne',
        eventData: {
          index
        }
      })
      this.chooseWhich = index
    },
    voteNow() {
      if (this.chooseWhich == -1) {
        Toast('请先勾选候选人')
        return
      }
      var authorId = this.getList[this.chooseWhich].authorId
      Log.click({
        eventId: 'voteNow',
        eventData: { authorId }
      })
      api.vote.postVoteName({ authorId: authorId }).then(res => {
        // console.log(res, 463434364)
        if (res.result.code === 0) {
          this.showDialog = true
        } else {
          Toast(res.result.msg)
        }
      })
    },
    lookRank() {
      if (isGuest()) {
        util.go('ycstock://login')
        return
      }
      Log.click({
        eventId: 'lookRank',
        eventData: {}
      })
      this.$router.push({
        path: './vote-rank'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.vote-box {
  .vote-tip {
    padding: 80px 0;
    text-align: center;
  }
  .vote-choose {
    background: #fff;
    border-radius: 16px;
    padding: 51px 0 60px 40px;
    flex-wrap: wrap;
    .vote-list {
      position: relative;
      width: 50%;
      justify-content: left;
      margin-bottom: 32px;
      img {
        display: block;
        width: 30px;
        height: 30px;
        margin-right: 16px;
      }
      span {
        line-height: 1;
      }
      &:last-child,
      &:nth-last-child(2) {
        margin-bottom: 0;
      }
    }
  }
  .btn-box {
    justify-content: center;
    margin-top: 50px;
    span {
      display: block;
      width: 300px;
      line-height: 1;
      padding: 30px 0;
      text-align: center;
      background: linear-gradient(0deg, #feaa08 0%, #fee14f 100%);
      border-radius: 45px;
      &:first-child {
        margin-right: 40px;
      }
    }
  }
}
</style>
